import React from 'react';

import { canCurrentUserSeeParapetLoads } from '../../../../store/selectors/parapetLoadSelectors';
import { useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function AdditionalLoadsMenu() {
  const currentUserCanSeeParapetLoads = useAppSelector(canCurrentUserSeeParapetLoads);
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="manualLoad" />
      <AddItemMenuItem type="movingLoad" />
      {currentUserCanSeeParapetLoads && <AddItemMenuItem type="parapetLoad" userVisibleTerm="PAL Load" />}
    </SceneMenuContent>
  );
}
